export const statuses = ["DRAFT", "SENT", "PAID", "DUE", "ARCHIVED"];

// TODO: get currencies and conversion rates from an API
export const currencies = [
  { id: "EUR", name: "Euro", symbol: "€" },
  { id: "USD", name: "US Dollar", symbol: "$" },
  { id: "GBP", name: "British Pound", symbol: "£" },
  { id: "CHF", name: "Swiss Franc", symbol: "CHF" },
  { id: "CAD", name: "Canadian Dollar", symbol: "CA$" },
  { id: "AUD", name: "Australian Dollar", symbol: "AU$" },
  { id: "YEN", name: "Japanese Yen", symbol: "¥" },
  { id: "JPY", name: "Japanese Yen", symbol: "¥" },
  { id: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
  { id: "SEK", name: "Swedish Krona", symbol: "kr" },
  { id: "CNH", name: "Chinese Yuan", symbol: "CN¥" },
  { id: "PLN", name: "Polish Zloty", symbol: "zł" },
  { id: "AED", name: "UAE Dirham", symbol: "AED" },
  { id: "SGD", name: "Singapore Dollar", symbol: "SGD" },
  { id: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { id: "RON", name: "Romanian Leu", symbol: "RON" },
  { id: "KRW", name: "South Korean Won", symbol: "₩" },
  { id: "TRY", name: "Turkish Lira", symbol: "₺" },
  { id: "RSD", name: "Serbian Dinar", symbol: "RSD" },
  { id: "BAM", name: "Bosnia-Herzegovina Convertible Mark", symbol: "BAM" },
  { id: "XOF", name: "West African CFA Franc", symbol: "CFA" },
  { id: "BRL", name: "Brazilian Real", symbol: "R$" },
  { id: "MAD", name: "Moroccan Dirham", symbol: "MAD" },
  { id: "VND", name: "Vietnamese Dong", symbol: "₫" },
  { id: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
];

export const phoneIndicatifs = [
  // Albanie
  { id: "+355", name: "AL", flag: "🇦🇱", placeholder: "68 123 4567", countryNameFr: "Albanie", countryNameEn: "Albania" },
  // Andorre
  { id: "+376", name: "AD", flag: "🇦🇩", placeholder: "612 345", countryNameFr: "Andorre", countryNameEn: "Andorra" },
  // Autriche
  { id: "+43", name: "AT", flag: "🇦🇹", placeholder: "664 123456", countryNameFr: "Autriche", countryNameEn: "Austria" },
  // Biélorussie
  { id: "+375", name: "BY", flag: "🇧🇾", placeholder: "29 123-45-67", countryNameFr: "Biélorussie", countryNameEn: "Belarus" },
  // Belgique
  { id: "+32", name: "BE", flag: "🇧🇪", placeholder: "470 12 34 56", countryNameFr: "Belgique", countryNameEn: "Belgium" },
  // Bosnie-Herzégovine
  { id: "+387", name: "BA", flag: "🇧🇦", placeholder: "61 123 456", countryNameFr: "Bosnie-Herzégovine", countryNameEn: "Bosnia and Herzegovina" },
  // Bulgarie
  { id: "+359", name: "BG", flag: "🇧🇬", placeholder: "87 123 4567", countryNameFr: "Bulgarie", countryNameEn: "Bulgaria" },
  // Croatie
  { id: "+385", name: "HR", flag: "🇭🇷", placeholder: "91 234 5678", countryNameFr: "Croatie", countryNameEn: "Croatia" },
  // Chypre
  { id: "+357", name: "CY", flag: "🇨🇾", placeholder: "96 123456", countryNameFr: "Chypre", countryNameEn: "Cyprus" },
  // République tchèque
  { id: "+420", name: "CZ", flag: "🇨🇿", placeholder: "601 123 456", countryNameFr: "République tchèque", countryNameEn: "Czech Republic" },
  // Danemark
  { id: "+45", name: "DK", flag: "🇩🇰", placeholder: "20 12 34 56", countryNameFr: "Danemark", countryNameEn: "Denmark" },
  // Estonie
  { id: "+372", name: "EE", flag: "🇪🇪", placeholder: "5123 456", countryNameFr: "Estonie", countryNameEn: "Estonia" },
  // Finlande
  { id: "+358", name: "FI", flag: "🇫🇮", placeholder: "40 123 4567", countryNameFr: "Finlande", countryNameEn: "Finland" },
  // France
  { id: "+33", name: "FR", flag: "🇫🇷", placeholder: "6 43 67 97 11", countryNameFr: "France", countryNameEn: "France" },
  // Allemagne
  { id: "+49", name: "DE", flag: "🇩🇪", placeholder: "151 12345678", countryNameFr: "Allemagne", countryNameEn: "Germany" },
  // Grèce
  { id: "+30", name: "GR", flag: "🇬🇷", placeholder: "691 234 5678", countryNameFr: "Grèce", countryNameEn: "Greece" },
  // Hongrie
  { id: "+36", name: "HU", flag: "🇭🇺", placeholder: "20 123 4567", countryNameFr: "Hongrie", countryNameEn: "Hungary" },
  // Islande
  { id: "+354", name: "IS", flag: "🇮🇸", placeholder: "611 1234", countryNameFr: "Islande", countryNameEn: "Iceland" },
  // Irlande
  { id: "+353", name: "IE", flag: "🇮🇪", placeholder: "85 123 4567", countryNameFr: "Irlande", countryNameEn: "Ireland" },
  // Italie
  { id: "+39", name: "IT", flag: "🇮🇹", placeholder: "312 345 6789", countryNameFr: "Italie", countryNameEn: "Italy" },
  // Kosovo
  { id: "+383", name: "XK", flag: "🇽🇰", placeholder: "43 123 456", countryNameFr: "Kosovo", countryNameEn: "Kosovo" },
  // Lettonie
  { id: "+371", name: "LV", flag: "🇱🇻", placeholder: "21 123 456", countryNameFr: "Lettonie", countryNameEn: "Latvia" },
  // Liechtenstein
  { id: "+423", name: "LI", flag: "🇱🇮", placeholder: "660 1234", countryNameFr: "Liechtenstein", countryNameEn: "Liechtenstein" },
  // Lituanie
  { id: "+370", name: "LT", flag: "🇱🇹", placeholder: "612 34567", countryNameFr: "Lituanie", countryNameEn: "Lithuania" },
  // Luxembourg
  { id: "+352", name: "LU", flag: "🇱🇺", placeholder: "628 123 456", countryNameFr: "Luxembourg", countryNameEn: "Luxembourg" },
  // Malte
  { id: "+356", name: "MT", flag: "🇲🇹", placeholder: "7912 3456", countryNameFr: "Malte", countryNameEn: "Malta" },
  // Moldavie
  { id: "+373", name: "MD", flag: "🇲🇩", placeholder: "79 123 456", countryNameFr: "Moldavie", countryNameEn: "Moldova" },
  // Monaco
  { id: "+377", name: "MC", flag: "🇲🇨", placeholder: "6 12 34 56 78", countryNameFr: "Monaco", countryNameEn: "Monaco" },
  // Monténégro
  { id: "+382", name: "ME", flag: "🇲🇪", placeholder: "67 123 456", countryNameFr: "Monténégro", countryNameEn: "Montenegro" },
  // Pays-Bas
  { id: "+31", name: "NL", flag: "🇳🇱", placeholder: "6 12345678", countryNameFr: "Pays-Bas", countryNameEn: "Netherlands" },
  // Macédoine du Nord
  { id: "+389", name: "MK", flag: "🇲🇰", placeholder: "70 123 456", countryNameFr: "Macédoine du Nord", countryNameEn: "North Macedonia" },
  // Norvège
  { id: "+47", name: "NO", flag: "🇳🇴", placeholder: "412 34 567", countryNameFr: "Norvège", countryNameEn: "Norway" },
  // Pologne
  { id: "+48", name: "PL", flag: "🇵🇱", placeholder: "512 345 678", countryNameFr: "Pologne", countryNameEn: "Poland" },
  // Portugal
  { id: "+351", name: "PT", flag: "🇵🇹", placeholder: "912 345 678", countryNameFr: "Portugal", countryNameEn: "Portugal" },
  // Roumanie
  { id: "+40", name: "RO", flag: "🇷🇴", placeholder: "712 345 678", countryNameFr: "Roumanie", countryNameEn: "Romania" },
  // Russie (partiellement en Europe)
  { id: "+7", name: "RU", flag: "🇷🇺", placeholder: "912 345-67-89", countryNameFr: "Russie", countryNameEn: "Russia" },
  // Saint-Marin
  { id: "+378", name: "SM", flag: "🇸🇲", placeholder: "66 123456", countryNameFr: "Saint-Marin", countryNameEn: "San Marino" },
  // Serbie
  { id: "+381", name: "RS", flag: "🇷🇸", placeholder: "60 1234567", countryNameFr: "Serbie", countryNameEn: "Serbia" },
  // Slovaquie
  { id: "+421", name: "SK", flag: "🇸🇰", placeholder: "912 345 678", countryNameFr: "Slovaquie", countryNameEn: "Slovakia" },
  // Slovénie
  { id: "+386", name: "SI", flag: "🇸🇮", placeholder: "31 234 567", countryNameFr: "Slovénie", countryNameEn: "Slovenia" },
  // Espagne
  { id: "+34", name: "ES", flag: "🇪🇸", placeholder: "612 345 678", countryNameFr: "Espagne", countryNameEn: "Spain" },
  // Suède
  { id: "+46", name: "SE", flag: "🇸🇪", placeholder: "70 123 45 67", countryNameFr: "Suède", countryNameEn: "Sweden" },
  // Suisse
  { id: "+41", name: "CH", flag: "🇨🇭", placeholder: "78 123 45 67", countryNameFr: "Suisse", countryNameEn: "Switzerland" },
  // Ukraine
  { id: "+380", name: "UA", flag: "🇺🇦", placeholder: "50 123 4567", countryNameFr: "Ukraine", countryNameEn: "Ukraine" },
  // Royaume-Uni
  { id: "+44", name: "UK", flag: "🇬🇧", placeholder: "7911 123456", countryNameFr: "Royaume-Uni", countryNameEn: "United Kingdom" },
  // Vatican
  { id: "+379", name: "VA", flag: "🇻🇦", placeholder: "123 456 789", countryNameFr: "Vatican", countryNameEn: "Vatican City" },

  // Déjà présents ou hors Europe (pour référence, à garder ou retirer selon besoin)
  { id: "+971", name: "AE", flag: "🇦🇪", placeholder: "50 123 4567", countryNameFr: "Émirats arabes unis", countryNameEn: "United Arab Emirates" },
  { id: "+1", name: "US", flag: "🇺🇸", placeholder: "123 456 7890", countryNameFr: "États-Unis", countryNameEn: "United States" },
  { id: "+86", name: "CN", flag: "🇨🇳", placeholder: "139 1234 5678", countryNameFr: "Chine", countryNameEn: "China" },
  { id: "+91", name: "IN", flag: "🇮🇳", placeholder: "91234 56789", countryNameFr: "Inde", countryNameEn: "India" },
  { id: "+81", name: "JP", flag: "🇯🇵", placeholder: "90-1234-5678", countryNameFr: "Japon", countryNameEn: "Japan" },
  { id: "+61", name: "AU", flag: "🇦🇺", placeholder: "412 345 678", countryNameFr: "Australie", countryNameEn: "Australia" },
  { id: "+1", name: "CA", flag: "🇨🇦", placeholder: "416 123 4567", countryNameFr: "Canada", countryNameEn: "Canada" },
  { id: "+55", name: "BR", flag: "🇧🇷", placeholder: "11 91234-5678", countryNameFr: "Brésil", countryNameEn: "Brazil" },
  { id: "+27", name: "ZA", flag: "🇿🇦", placeholder: "82 123 4567", countryNameFr: "Afrique du Sud", countryNameEn: "South Africa" },
  { id: "+234", name: "NG", flag: "🇳🇬", placeholder: "803 123 4567", countryNameFr: "Nigéria", countryNameEn: "Nigeria" },
  { id: "+62", name: "ID", flag: "🇮🇩", placeholder: "812-3456-7890", countryNameFr: "Indonésie", countryNameEn: "Indonesia" },
  { id: "+82", name: "KR", flag: "🇰🇷", placeholder: "10-1234-5678", countryNameFr: "Corée du Sud", countryNameEn: "South Korea" },
  { id: "+63", name: "PH", flag: "🇵🇭", placeholder: "912 345 6789", countryNameFr: "Philippines", countryNameEn: "Philippines" },
  { id: "+92", name: "PK", flag: "🇵🇰", placeholder: "300 1234567", countryNameFr: "Pakistan", countryNameEn: "Pakistan" },
  { id: "+20", name: "EG", flag: "🇪🇬", placeholder: "100 123 4567", countryNameFr: "Égypte", countryNameEn: "Egypt" },
  { id: "+212", name: "MA", flag: "🇲🇦", placeholder: "612-345678", countryNameFr: "Maroc", countryNameEn: "Morocco" },
  { id: "+216", name: "TN", flag: "🇹🇳", placeholder: "20 123 456", countryNameFr: "Tunisie", countryNameEn: "Tunisia" },
  { id: "+213", name: "DZ", flag: "🇩🇿", placeholder: "661 23 45 67", countryNameFr: "Algérie", countryNameEn: "Algeria" },
  { id: "+998", name: "UZ", flag: "🇺🇿", placeholder: "90 123 45 67", countryNameFr: "Ouzbékistan", countryNameEn: "Uzbekistan" },
  { id: "+94", name: "LK", flag: "🇱🇰", placeholder: "71 234 5678", countryNameFr: "Sri Lanka", countryNameEn: "Sri Lanka" },
  { id: "+66", name: "TH", flag: "🇹🇭", placeholder: "81 234 5678", countryNameFr: "Thaïlande", countryNameEn: "Thailand" },
  { id: "+84", name: "VN", flag: "🇻🇳", placeholder: "91 234 5678", countryNameFr: "Vietnam", countryNameEn: "Vietnam" },
  { id: "+880", name: "BD", flag: "🇧🇩", placeholder: "1712-345678", countryNameFr: "Bangladesh", countryNameEn: "Bangladesh" },
  { id: "+60", name: "MY", flag: "🇲🇾", placeholder: "12-345 6789", countryNameFr: "Malaisie", countryNameEn: "Malaysia" },
  { id: "+65", name: "SG", flag: "🇸🇬", placeholder: "9123 4567", countryNameFr: "Singapour", countryNameEn: "Singapore" },
  { id: "+64", name: "NZ", flag: "🇳🇿", placeholder: "21 123 4567", countryNameFr: "Nouvelle-Zélande", countryNameEn: "New Zealand" },
];

export const PRICING_FEATURES = {
  starter: {
    userLimit: 1,
    bankLimit: 1,
    aiCopilot: false,
    stripeConnect: false,
    customInvoice: false,
    sendInvoiceByEmail: false,
    paymentLink: false,
    emailImport: false,
    // DASHBOARD
    cashFlowDashboard: false,
    profitAndLossDashboard: false,
  },
  lite: {
    userLimit: 9999,
    bankLimit: 9999,
    aiCopilot: true,
    stripeConnect: true,
    customInvoice: false,
    sendInvoiceByEmail: false,
    paymentLink: false,
    emailImport: false,
    // DASHBOARD
    cashFlowDashboard: false,
    profitAndLossDashboard: false,
  },
  business: {
    userLimit: 9999,
    bankLimit: 9999,
    aiCopilot: true,
    stripeConnect: true,
    customInvoice: true,
    sendInvoiceByEmail: true,
    paymentLink: true,
    emailImport: true,
    // DASHBOARD
    cashFlowDashboard: true,
    profitAndLossDashboard: true,
  },
  free: {
    userLimit: 9999,
    bankLimit: 9999,
    aiCopilot: true,
    stripeConnect: true,
    customInvoice: true,
    sendInvoiceByEmail: true,
    paymentLink: true,
    emailImport: true,
    // DASHBOARD
    cashFlowDashboard: true,
    profitAndLossDashboard: true,
  },
};
